// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getLowestCountry = (
  countries: {
    rank: number;
    country_name: string;
  }[]
): any => {
  return (
    countries?.length !== 0 &&
    countries?.reduce((prev, current) =>
      Number(prev?.rank) <= Number(current?.rank) ? prev : current
    )
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getHighestCountry = (
  countries: {
    mentions: number;
    country_name: string;
  }[]
): any => {
  return (
    countries?.length !== 0 &&
    countries?.[0].country_name !== '' &&
    countries?.reduce((prev, current) =>
      prev?.mentions >= current?.mentions ? prev : current
    )
  );
};
